import { gql } from '@/lib/utils'
import type { NetsCheckoutMutation, NetsCheckoutMutationVariables } from '@/service-api/nets-checkout.generated'
import type { GetServerBasketQuery } from '@/service-api/basket.generated'
import type { BasketModelInput } from '@/service-api/types.generated'

export async function serviceApi({
  uri = `${process.env.NEXT_PUBLIC_SERVICE_API_URL}/api/graphql`,
  query,
  variables = {},
}: any) {
  const body = JSON.stringify({ query, variables })

  try {
    const response = await fetch(uri, {
      method: 'post',
      headers: {
        'content-type': 'application/json',
      },
      body,
    })

    if (!response.ok) {
      throw new Error(await response.text())
    }

    const json = await response.json()

    if (json.errors) {
      console.error('Service API encountered an error', json.errors)
    }

    return json
  } catch (error) {
    console.error('Service API encountered an error', error)
    throw error
  }
}

export const getNetsCheckout = async (
  checkoutModel: NetsCheckoutMutationVariables['checkoutModel'],
): Promise<NetsCheckoutMutation> => {
  const query = gql`
    mutation NetsCheckout($checkoutModel: CheckoutModelInput!) {
      paymentProviders {
        nets {
          createPayment(checkoutModel: $checkoutModel) {
            success
            paymentUrl
            paymentId
          }
        }
      }
    }
  `

  const response = await serviceApi({
    query,
    variables: { checkoutModel },
  })

  return response.data as NetsCheckoutMutation
}

export const getServerBasket = async (basketModel: BasketModelInput): Promise<GetServerBasketQuery> => {
  const query = gql`
    query basket($basketModel: BasketModelInput!) {
      basket(basketModel: $basketModel) {
        total {
          net
          gross
          tax {
            name
            percent
          }
          currency
          discount
        }
        cart {
          sku
          productName
          productImage
          name
          path
          quantity
          attributes {
            attribute
            value
          }
          price {
            net
            gross
            tax {
              name
              percent
            }
            currency
          }
          images {
            url
            variants {
              url
              width
              height
            }
          }
        }
      }
    }
  `

  const response = await serviceApi({
    query,
    variables: { basketModel },
  })

  return response.data as GetServerBasketQuery
}
